<script setup>
import OverviewText from './OverviewText.vue';
import LatestNews from '../LatestNews.vue';
import ContactForm from './ContactForm.vue';
import PropertiesGrid from '../PropertyPage/PropertiesGrid.vue';
import EstatesInLocation from './EstatesInLocation.vue';
</script>
<script>
export default {
    data() {
        return {
            detail: {
                name: '',
                long_description: '',
                banner: '',
                heading: '',
            },
            articles: {},
        };
    },
    computed: {
        slug() {
            const slug = new URL(location.href).pathname.match(/[^\/]+/g);
            return slug[slug.length - 1];
        },
    },
    methods: {
        getLocationArticle() {
            axios.get(`/locations/news/${this.slug}`).then((response) => {
                this.$data.articles = response.data.articles;
            });
        },
        getLocationDetail() {
            axios.get(`/locations/details/${this.slug}`).then((response) => {
                this.$data.detail = response.data.detail;
                this.$data.long_description = response.data.long_description;
                this.$data.banner = response.data.banner_image;
                this.$data.heading = response.data.heading;
            });
        },
    },
    mounted() {
        this.getLocationDetail();
        this.getLocationArticle();
    },
};
</script>

<template>
    <div class="tw-space-y-14">
        <OverviewText
            :description="detail.heading_description"
            :banner="detail.banner_image"
            :heading="detail.heading"
        >
        </OverviewText>
        <div class="tw-px-4 lg:tw-px-24 xxl:tw-px-28 tw-space-y-5">
            <div class="mt-20px tw-grid tw-grid-cols-1 md:tw-grid-cols-1 lg:tw-grid-cols-1 xl:tw-grid-cols-[auto,1fr] tw-gap-6">
                <div class="tw-order-2 md:tw-order-2 lg:tw-order-2 xl:tw-order-1 tw-min-w-[320px] lg:tw-min-h-[320px] tw-max-h-[480px] tw-max-w-[745px]">
                    <img :src="detail.banner_image" class="img-fluid " />
                </div>
                <div class="col-12 tw-order-1 md:tw-order-1 lg:tw-order-1 xl:tw-order-2">
                    <h2 class="fs-32px fw-bold tw-text-darkGreen">
                    {{ detail.overview_header }}
                    </h2>
                    <div class="tw-text-[#2C2C2C]" v-html="detail.long_description"></div>
                </div>
            </div>
        </div>
        <EstatesInLocation
            :title="'Estates in ' + detail.name"
            :banner="detail.banner_image"
        ></EstatesInLocation>
        <PropertiesGrid
            :slidesPerView_MD="4"
            :slidesPerGroup_MD="8"
            :spaceBetween_MD="0"
            :gridRows_MD="2"
            :slidesPerView_XL="4"
            :slidesPerGroup_XL="8"
            :title="'Properties in ' + detail.name"
            :enableQuickSearch="false"
            :filteredBySlug="true"
        ></PropertiesGrid>
        <section class="tw-relative">
            <LatestNews
                :title="'Latest ' + detail.name + ' News'"
                description="We've built traditions and developed new inspirations for living. Our master-planned estates include residential and commercial spaces, built in mind for those who want to live, work, and play with everything they want and need within reach."
                button_text="MORE STORIES"
                :items="articles"
            >
            </LatestNews>
        </section>
        <ContactForm></ContactForm>
    </div>
</template>
